import { forwardRef } from 'react';
import { ModernNotification } from './NotificationTypes';
import NotificationItem from './NotificationItem';

interface NotificationDropdownProps {
  isOpen: boolean;
  notifications: ModernNotification[];
  unreadCount: number;
  onMarkAsRead: (id: string) => void;
  onMarkAllAsRead: () => void;
  onDelete?: (id: string) => void;
  onViewAll: () => void;
  isLoading?: boolean;
}

const NotificationDropdown = forwardRef<HTMLDivElement, NotificationDropdownProps>(
  ({ isOpen, notifications, unreadCount, onMarkAsRead, onMarkAllAsRead, onDelete, onViewAll, isLoading }, ref) => {
    if (!isOpen) return null;

    return (
      <div
        ref={ref}
        className="tw-absolute tw-right-0 tw-mt-2 tw-w-80 tw-origin-top-right tw-rounded-lg tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none tw-z-50"
      >
        <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-gray-200 tw-px-4 tw-py-3">
          <h3 className="tw-text-base tw-font-semibold tw-text-gray-800">
            Notifications
          </h3>
          {unreadCount > 0 && (
            <button
              onClick={onMarkAllAsRead}
              className="tw-text-sm tw-font-medium tw-text-primary hover:tw-text-primary/80"
            >
              Mark all as read
            </button>
          )}
        </div>

        <div className="tw-max-h-96 tw-overflow-y-auto">
          {isLoading ? (
            <div className="tw-flex tw-items-center tw-justify-center tw-p-8">
              <div className="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-b-2 tw-border-primary"></div>
            </div>
          ) : notifications.length > 0 ? (
            notifications.map((notification) => (
              <NotificationItem
                key={notification.id}
                notification={notification}
                onMarkAsRead={onMarkAsRead}
                onDelete={onDelete}
              />
            ))
          ) : (
            <div className="tw-text-center tw-text-gray-500 tw-p-8">
              <span className="material-symbols-outlined tw-text-3xl tw-text-gray-300 tw-block tw-mb-2">
                notifications_none
              </span>
              <p className="tw-text-sm">No notifications yet</p>
            </div>
          )}
        </div>

        {notifications.length > 0 && (
          <div className="tw-border-t tw-border-gray-200 tw-p-2">
            <button
              onClick={onViewAll}
              className="tw-block tw-w-full tw-rounded-md tw-px-4 tw-py-2 tw-text-center tw-text-sm tw-font-medium tw-text-primary hover:tw-bg-gray-100"
            >
              View all notifications
            </button>
          </div>
        )}
      </div>
    );
  }
);

NotificationDropdown.displayName = 'NotificationDropdown';

export default NotificationDropdown;